// extracted by mini-css-extract-plugin
module.exports = {"container":"Suche_container__33mcS","actions":"Suche_actions__DlzeW","labelQuick":"Suche_labelQuick__FpO9X","labelDetail":"Suche_labelDetail__qskih"};